var render, staticRenderFns
import script from "./Common.vue?vue&type=script&lang=js&"
export * from "./Common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Common.vue"
export default component.exports